import { Injectable } from '@angular/core';
import {
    LPBody,
    LPContent,
    LPContentItem,
} from './listing-page/listing-page.data';
import { MarcheAPIService } from '../@core/api/marche-api.service';
import { stringify } from 'querystring';
import { Observable, of } from 'rxjs';
import {
    ErrorWrapper,
    ResponseWrapper,
} from '../@shared/models/response-wrapper.model';
import { tap } from 'rxjs/operators';
import { ApplicationRouterService } from '../@core/application-router/application-router.service';

@Injectable({
    providedIn: 'root',
})
export class ListingPageService {
    static readonly LP_CONTENT_API = '/lp/content/v3?page=';
    static readonly COLP_CONTENT_API = '/clp/content/v3?page=';
    currentPage = -1;
    listingData: LPContentItem[] = [];
    errors: ErrorWrapper[] | undefined = [];
    filters: { [p: string]: string | string[] } = {};
    scrollPos = -1;
    LPBody?: LPBody = {
        onlyActive: 0,
        onlyOOS: 0,
    };
    private pageScrollPositions: { [page: number]: number } = {};
    constructor(
        private marcheAPIService: MarcheAPIService,
        private applicationRouterService: ApplicationRouterService
    ) {}

    getListingData(
        filters: { [p: string]: string | string[] },
        page: number,
        changeListingUrl?: boolean
    ): Observable<any> {
        if (
            stringify(filters) === stringify(this.filters) &&
            this.currentPage === page
        ) {
            this.applicationRouterService.differNavApiCall.emit({
                navCall: true,
                pageId: 'lp',
            });
            if (this.errors?.length === 0) {
                return of({
                    success: true,
                    data: {
                        feed: this.listingData,
                        activeProducts: this.LPBody?.onlyActive,
                        cached: true,
                        oosProducts: this.LPBody?.onlyOOS,
                    },
                });
            } else {
                return of({
                    success: false,
                    errors: this.errors,
                });
            }
        } else {
            return this.marcheAPIService
                .postRequest<ResponseWrapper<LPContent>>(
                    (changeListingUrl
                        ? ListingPageService.COLP_CONTENT_API
                        : ListingPageService.LP_CONTENT_API) + page,
                    filters,
                    this.LPBody
                )
                .pipe(
                    tap(res => {
                        if (res?.success) {
                            if (page === 0) {
                                this.listingData = [];
                                this.applicationRouterService.differNavApiCall.emit(
                                    { navCall: true, pageId: 'lp' }
                                );
                            }
                            //@ts-ignore
                            this.listingData?.push(...res!.data.feed);
                            this.currentPage = page;
                            this.filters = filters;
                            this.errors = [];
                            this.LPBody = {
                                onlyActive: res.data.activeProducts,
                                onlyOOS: res.data.oosProducts,
                            };
                        } else {
                            this.applicationRouterService.differNavApiCall.emit(
                                { navCall: true, pageId: 'lp' }
                            );
                        }
                    })
                );
        }
    }

    getCurrentPage(): number {
        return this.currentPage;
    }

    setScrollPosRestore(scroll: number) {
        this.scrollPos = scroll;
    }

    getScrollPos(filters: { [p: string]: string | string[] }): number {
        if (stringify(filters) === stringify(this.filters)) {
            return this.scrollPos;
        } else {
            return -1;
        }
    }

    getFilters(): { [p: string]: string | string[] } {
        return this.filters;
    }

    setScrollPosition(page: number, scrollPos: number) {
        console.log(page, 'page-number-set');
        console.log(scrollPos, 'set-scroll');
        this.pageScrollPositions[page] = scrollPos;
    }

    getScrollPosition(page: number): number {
        console.log(page, 'get-scroll', this.pageScrollPositions[page++]);
        return this.pageScrollPositions[page++];
    }
}
